import React from "react";
import { EntityCrudPage } from "./EntityCrudPage";

export function ProductCategoriesPage() {
  return (
    <EntityCrudPage
      title="Product Categories"
      itemLabel="Product Category"
      subtitle="Manage product categories for customers."
      endpoint="/api/ProductCategories"
      customerScoped
      listColumns={[
        { key: "image", label: "Image", type: "image" },
        { key: "code", label: "Code" },
        { key: "name", label: "Name" },
        { key: "description", label: "Description", oneLine: true },
        { key: "order", label: "Order" },
        { key: "customerName", label: "Customer" }
      ]}
      fields={[
        { key: "code", label: "Code" },
        { key: "name", label: "Name", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "order", label: "Order", type: "number" },
        { key: "image", label: "Image", type: "image" }
      ]}
    />
  );
}
